import { render, staticRenderFns } from "./ListBonification.vue?vue&type=template&id=7170c624"
import script from "./ListBonification.vue?vue&type=script&lang=js"
export * from "./ListBonification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports